import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export const useAuthStore = create<{
    isAuthenticated: boolean,
    setIsAuthenticated: (isAuthenticated: boolean) => void;
    isLoading: boolean,
    setIsLoading: (isLoading: boolean) => void;
}>()(
    persist(
        (set) => ({
            isAuthenticated: false,
            setIsAuthenticated: (isAuthenticated: boolean) => set({ isAuthenticated }),
            isLoading: true,
            setIsLoading: (isLoading: boolean) => set({ isLoading }),
        }),
        {
            name: 'auth',
            storage: createJSONStorage(() => localStorage),
        },
    ),
)